import React from 'react'

const Header = () => {
    return <header>Food Factory</header>;
}

export default Header;